import React from "react"
import { addressItem } from "../carnet-adresse.module.scss"
import PropTypes from "prop-types"
import AddressContent from "../AddressContent/address-content"
import EditButton from "../../../EditButton/edit-button"

const RenderAddresses = ({ addressesData }) => {
  const addresses = addressesData.allNodeCarnetDAdresse.edges
  return (
    <>
      {addresses.map(({ node }) => (
        <div key={node.drupal_id} className={addressItem} role={"listitem"}>
          <EditButton link={"/node/" + node.drupal_internal__nid + "/edit"} />
          <AddressContent address={node} />
        </div>
      ))}
    </>
  )
}

RenderAddresses.propTypes = {
  addressesData: PropTypes.object.isRequired,
}

export default RenderAddresses
